import { RouteConfig } from 'vue-router'

const LAYOUT = () => import('@/layout/index.vue')

/** 子路由 meta；父级 layout 另用 metaParent */
function meta (title: string, hidden = false) {
  return { hidden, icon: '', link: '', target: null, title }
}

/** 侧栏一级菜单：默认不展开子菜单（仅 business 模块 layout 使用） */
function metaParent (title: string) {
  return { ...meta(title), sidebarDefaultOpen: false as const }
}

function layout (
  path: string,
  name: string,
  title: string,
  children: RouteConfig[],
  redirect?: string
): RouteConfig {
  return {
    component: LAYOUT,
    meta: metaParent(title),
    name,
    path,
    ...(redirect ? { redirect } : {}),
    children
  }
}

export const businessRoute: RouteConfig[] = [
  layout('/task', 'store_manager', '任务管理', [
    {
      component: () => import('@/views/business/taskManage/index.vue'),
      meta: meta('任务管理'),
      name: 'taskManage_list',
      path: 'taskManage/index'
    }
  ]),
  layout('/entry', 'entry_manager', '报名管理', [
    {
      component: () => import('@/views/business/entryManage/index.vue'),
      meta: meta('报名管理'),
      name: 'entryManager_list',
      path: 'entryManage/index'
    }
  ]),
  layout('/task', 'task_prize', '进阶任务审核', [{
    component: () => import('@/views/business/taskPrize/index.vue'),
    meta: meta('进阶任务审核'),
    name: 'taskPrize_list',
    path: 'taskPrize/index'
  }]),
  layout('/entry', 'entry_manager', '达人审核', [
    {
      component: () => import('@/views/business/talentAuth/index.vue'),
      meta: meta('达人审核'),
      name: 'talent_auth',
      path: 'talentAuth/index'
    }
  ]),
  layout('/entryManagePt', 'entryManage_Pt', '平台管理', [
    {
      component: () => import('@/views/business/financeManage/storeMange/index.vue'),
      meta: meta('商户管理'),
      name: 'storeMange_list',
      path: 'storeMange/index'
    },
    {
      component: () => import('@/views/business/entryManagePt/index.vue'),
      meta: meta('任务佣金'),
      name: 'entryManage_list',
      path: 'entryManage/index'
    }
  ]),
  layout('/businessFlow', 'business_flow', '流水管理', [
    {
      component: () => import('@/views/business/financeManage/businessFlow/index.vue'),
      meta: meta('商家流水'),
      name: 'businessFlow_list',
      path: 'businessFlow/index'
    },
    {
      component: () => import('@/views/business/financeManage/talentFlow/index.vue'),
      meta: meta('达人流水'),
      name: 'talentFlow_list',
      path: 'talentFlow/index'
    }
  ]),
  layout('/companyPrize', 'company_prize', '奖品管理', [
    {
      component: () => import('@/views/business/prizeManage/companyPrize/index.vue'),
      meta: meta('商家奖品'),
      name: 'companyPrize_list',
      path: 'companyPrize/index'
    },
    {
      component: () => import('@/views/business/prizeManage/userPrize/index.vue'),
      meta: meta('素人奖品'),
      name: 'userPrize_list',
      path: 'userPrize/index'
    }
  ]),
  layout('/talent', 'talent_pool', '达人管理', [
    {
      component: () => import('@/views/business/talentPool/index.vue'),
      meta: meta('抖音达人'),
      name: 'talentPool_list',
      path: 'talentPool/index'
    },
    {
      component: () => import('@/views/business/xhsTalentPool/index.vue'),
      meta: meta('小红书达人'),
      name: 'xhsTalentPool_list',
      path: 'xhsTalentPool/index'
    },
    {
      component: () => import('@/views/business/dpTalentPool/index.vue'),
      meta: meta('大众点评达人'),
      name: 'dpTalentPool_list',
      path: 'dpTalentPool/index'
    }
  ]),

  // layout('/videoManage', 'taskVideo_manager', '素材管理', [
  //   {
  //     component: () => import('@/views/business/taskVideo/index.vue'),
  //     meta: meta('视频素材'),
  //     name: 'taskVideo_list',
  //     path: 'taskVideo/index'
  //   },
  //   {
  //     component: () => import('@/views/business/taskImages/index.vue'),
  //     meta: meta('图片素材管理'),
  //     name: 'taskImages_list',
  //     path: 'taskImages/index'
  //   }
  // ]),
  layout('/toolManager', 'moreTool_manager', '更多工具管理', [
    {
      component: () => import('@/views/business/moreTool/index.vue'),
      meta: meta('更多工具'),
      name: 'moreTool_list',
      path: 'moreTool/index'
    }
  ]),
  layout('/associationConfig', 'association_config', '协会配置', [
    {
      component: () => import('@/views/association/config/index.vue'),
      meta: meta('协会配置'),
      name: 'association_config_list',
      path: 'config/index'
    }
  ]),
  layout('/associationStaff', 'association_staff', '协会成员', [
    {
      component: () => import('@/views/association/staff/index.vue'),
      meta: meta('协会成员'),
      name: 'association_staff_list',
      path: 'staff/index'
    }
  ]),
  layout('/associationMeeting', 'association_meeting', '协会会议', [
    {
      component: () => import('@/views/association/meeting/index.vue'),
      meta: meta('协会会议'),
      name: 'association_meeting_list',
      path: 'meeting/index'
    }
  ]),
  layout('/postManage', 'post_manage', '推文管理', [
    {
      component: () => import('@/views/business/postManage/index.vue'),
      meta: meta('推文管理'),
      name: 'post_manage_list',
      path: 'postManage/index'
    }
  ]),
  layout('/memberManage', 'member_manage', '会员管理', [
    {
      component: () => import('@/views/business/memberManage/index.vue'),
      meta: meta('正式会员'),
      name: 'member_formal_list',
      path: 'formalMember/index'
    },
    {
      component: () => import('@/views/association/memberApplication/index.vue'),
      meta: meta('会员申请记录'),
      name: 'member_application_list',
      path: 'memberApplication/index'
    }
  ], 'formalMember/index'),
  layout('/safetyOfficer', 'safety_officer_mgmt', '食安员管理', [
    {
      component: () => import('@/views/association/companyManage/index.vue'),
      meta: meta('公司管理'),
      name: 'company_manage_list',
      path: 'companyManage/index'
    },
    {
      component: () => import('@/views/association/safetyOfficer/index.vue'),
      meta: meta('食安员列表'),
      name: 'safety_officer_list',
      path: 'officer/index'
    },
    {
      component: () => import('@/views/association/exam/index.vue'),
      meta: meta('考试管理'),
      name: 'exam_manage_list',
      path: 'exam/index'
    }
  ]),
  layout('/associationAdvise', 'association_advise', '用户反馈', [
    {
      component: () => import('@/views/association/advise/index.vue'),
      meta: meta('用户反馈'),
      name: 'association_advise_list',
      path: 'advise/index'
    }
  ])
]
